<template>
  <div class="ml-auto">
    <v-btn
      v-if="prev"
      class="text-capitalize secondary--text"
      text
      :loading="loading"
      @click="$emit('cancel')"
    >
      <slot name="cancel"> Cancel </slot>
    </v-btn>
    <v-btn
      v-if="next"
      class="text-capitalize ml-2"
      :class="text ? 'primary--text' : 'white--text'"
      :color="text ? '' : 'primary'"
      :text="text"
      :loading="loading"
      @click="$emit('success')"
    >
      <slot name="accept"> Accept </slot>
    </v-btn>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  props: {
    text: {
      required: false,
      default: true,
      type: Boolean,
    },
    prev: {
      required: false,
      default: true,
      type: Boolean,
    },
    next: {
      required: false,
      default: true,
      type: Boolean,
    },
    loading: Boolean,
  },
});
</script>
